import { del, put, post } from "../../../utils/axios";

export const createLocationOrgs = async (body) => {
  return await post("/location/assign", body);
};

export const updateLocationOrgs = async (query, body) => {
  return await put("/location/assign", {}, body);
};

export const delLocationOrgs = async (body) => {
  return await del("/location/unassign", {}, body);
};
